(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lux-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.luxStoreReady) return;
  window.luxStoreReady = true;
  document.body.classList.add('lux-ready');
  const decodeText = value => typeof value === 'string' ? new DOMParser().parseFromString(value, 'text/html').body.textContent : Object.fromEntries(Object.entries(value).map(([key, child]) => [key, decodeText(child)]));
  const strings = decodeText(JSON.parse(document.getElementById('lux-ui-text')?.textContent || '{}'));

  const root = window.Shopify?.routes?.root || '/';
  const cleanMoney = value => String(value || '').replace(/<[^>]*>/g, '');
  const dimensions = variant => {
    for (const option of variant.options) {
      const match = option.match(/(?:^|[^\d])(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
      if (match) return { width: Number(match[1].replace(',', '.')), height: Number(match[2].replace(',', '.')) };
    }
    return { width: null, height: null };
  };
  const status = variant => !variant?.available ? strings.soldOut : variant.managed && variant.inStock ? strings.inStock : strings.orderable;
  const openDialog = dialog => { if (dialog && !dialog.open) dialog.showModal(); };
  const setImage = (image, src) => {
    if (!image || !src) return;
    image.src = src;
    image.srcset = [360, 600, 900, 1200, 1400].map(width => { const url = new URL(src, location.origin); url.searchParams.set('width', width); return `${url.href} ${width}w`; }).join(', ');
  };
  function cartCount(count) {
    document.querySelectorAll('[data-lux-cart-count]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
  }
  function replaceDrawer(html, show = true) {
    if (!html) return false;
    const wrapper = document.getElementById('shopify-section-lux-cart-drawer');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('#lux-cart-drawer');
    if (!wrapper || !next) return false;
    wrapper.querySelector('dialog')?.close();
    wrapper.replaceChildren(document.importNode(next, true));
    const dialog = wrapper.querySelector('dialog');
    cartCount(Number(dialog.dataset.cartCount));
    if (show) openDialog(dialog);
    return true;
  }
  let cartBusy = false;
  async function changeCart(line, quantity, focusControl = 'input') {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    const dialog = line.closest('dialog');
    const error = dialog.querySelector('[data-lux-cart-error]');
    cartBusy = true;
    dialog.setAttribute('aria-busy', 'true');
    error.hidden = true;
    const previousQuantity = line.querySelector('input').defaultValue;
    const quantityInputId = line.querySelector('input').id;
    const previousScroll = dialog.querySelector('.lux-cart-lines')?.scrollTop || 0;
    const controls = [...dialog.querySelectorAll('input,[name="checkout"],[data-lux-qty-adjust]')].map(node => ({node,disabled:node.disabled}));
    const key = line.dataset.key;
    dialog.querySelectorAll('input,[name="checkout"],[data-lux-qty-adjust]').forEach(node => node.disabled = true);
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['lux-cart-drawer'], sections_url: location.pathname + location.search }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.error);
      if (!replaceDrawer(data.sections?.['lux-cart-drawer'])) { location.assign(`${root}cart`); return; }
      const nextDialog = document.getElementById('lux-cart-drawer');
      const nextLine = nextDialog.querySelector(`[data-key="${CSS.escape(key)}"]`) || (quantity > 0 ? nextDialog.querySelector(`#${CSS.escape(quantityInputId)}`)?.closest('[data-lux-cart-line]') : null);
      const nextScroller = nextDialog.querySelector('.lux-cart-lines');
      if (nextScroller) nextScroller.scrollTop = previousScroll;
      const requestedFocus = nextLine?.querySelector(focusControl);
      const focusTarget = requestedFocus && !requestedFocus.disabled ? requestedFocus : nextLine?.querySelector('.lux-cart-stepper') || nextDialog.querySelector('[data-lux-close]');
      focusTarget?.focus({ preventScroll: true });
    } catch (failure) {
      error.textContent = failure.message || strings.error;
      error.hidden = false;
      const input = line.querySelector('input');
      if (input) input.value = previousQuantity;
      controls.forEach(({node,disabled}) => node.disabled = disabled);
    } finally { cartBusy = false; dialog.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-lux-open]');
    if (opener) { event.preventDefault(); openDialog(document.getElementById(opener.dataset.luxOpen)); }
    const closer = event.target.closest('[data-lux-close]');
    if (closer) closer.closest('dialog')?.close();
    const cartOpener = event.target.closest('[data-lux-cart-open]');
    if (cartOpener && document.getElementById('lux-cart-drawer')) { event.preventDefault(); openDialog(document.getElementById('lux-cart-drawer')); }
    const adjuster = event.target.closest('[data-lux-qty-adjust]');
    if (adjuster && !cartBusy) {
      const line = adjuster.closest('[data-lux-cart-line]');
      const input = line.querySelector('[data-lux-cart-quantity]');
      if (Number(adjuster.dataset.luxQtyAdjust) > 0) input.stepUp(); else input.stepDown();
      if (input.reportValidity()) {
        if (line.closest('#lux-cart-drawer')) changeCart(line, Number(input.value), `[data-lux-qty-adjust="${adjuster.dataset.luxQtyAdjust}"]`);
        else input.form.requestSubmit(input.form.querySelector('[name="update"]'));
      }
    }
    const remover = event.target.closest('#lux-cart-drawer [data-lux-cart-remove]');
    if (remover) { event.preventDefault(); changeCart(remover.closest('[data-lux-cart-line]'), 0); }
    if (event.target instanceof HTMLDialogElement) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    if (event.target.closest('.lux-menu-links a')) event.target.closest('dialog')?.close();
    document.querySelectorAll('.lux-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.lux-nav details[open]').forEach(details => details.open = false); });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-lux-cart-quantity]') || !event.target.reportValidity()) return;
    if (event.target.closest('#lux-cart-drawer')) changeCart(event.target.closest('[data-lux-cart-line]'), Number(event.target.value));
    else event.target.form.requestSubmit(event.target.form.querySelector('[name="update"]'));
  });
  class LuxProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-lux-variants]').textContent);
      this.form = this.querySelector('.lux-buy-form');
      this.selector = this.form.querySelector('[name="id"]');
      this.current = this.variants.find(variant => String(variant.id) === this.dataset.currentId) || this.variants[0];
      this.selected = this.current.options.slice();
      this.busy = false;
      this.querySelectorAll('[data-lux-option]').forEach(radio => {
        radio.checked = this.selected[Number(radio.dataset.luxOption)] === radio.value;
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-lux-option]')) {
          this.selected[Number(event.target.dataset.luxOption)] = event.target.value;
          this.current = this.variants.find(variant => variant.options.every((option, i) => option === this.selected[i]));
          this.update(true);
        } else if (event.target === this.selector) {
          this.current = this.variants.find(variant => String(variant.id) === this.selector.value);
          this.selected = this.current.options.slice();
          this.querySelectorAll('[data-lux-option]').forEach(radio => radio.checked = this.selected[Number(radio.dataset.luxOption)] === radio.value);
          this.update(true);
        }
      }, { signal: this.abort.signal });
      this.form.addEventListener('input', event => { if (event.target.name === 'quantity') this.updatePayments(); }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-lux-thumbnail]');
        if (thumb) this.showImage(thumb.dataset.image, thumb.dataset.mediaId, thumb.dataset.alt);
        if (event.target.closest('[data-lux-zoom]')) { const image = this.querySelector('.lux-main-image'); const zoom = this.querySelector('[data-lux-zoom-image]'); zoom.src = image.currentSrc || image.src; zoom.alt = image.alt; openDialog(this.querySelector('[data-lux-zoom-dialog]')); }
        if (event.target.closest('[data-lux-sticky-options]')) {
          event.preventDefault();
          const target = this.form.querySelector('[data-lux-option]:checked') || this.form.querySelector('[name="quantity"]');
          target?.focus({ preventScroll: true });
          this.form.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
        if (event.target.closest('[data-lux-sticky-add]') && !this.busy) this.form.requestSubmit(this.form.querySelector('[data-lux-add]'));
      }, { signal: this.abort.signal });
      this.form.addEventListener('submit', event => this.addToCart(event), { signal: this.abort.signal });
      this.update(false);
      this.observer = new IntersectionObserver(() => this.scheduleSticky());
      this.observer.observe(this.form.querySelector('[data-lux-add]'));
      this.layoutObserver = new ResizeObserver(() => this.scheduleSticky());
      this.layoutObserver.observe(this.form);
      const header = document.querySelector('.shopify-section-group-header-group:has(.lux-header)');
      if (header) this.layoutObserver.observe(header);
      window.visualViewport?.addEventListener('resize', () => this.scheduleSticky(), { passive: true, signal: this.abort.signal });
      document.addEventListener('focusin', () => this.scheduleSticky(), { signal: this.abort.signal });
      document.addEventListener('focusout', () => this.scheduleSticky(), { signal: this.abort.signal });
      window.addEventListener('scroll', () => this.scheduleSticky(), { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', () => this.scheduleSticky(), { passive: true, signal: this.abort.signal });
      this.cookieObserver = new MutationObserver(() => this.scheduleSticky());
      this.cookieObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open','hidden','class','style'] });
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(value => String(value.id) === id);
        if (variant) { this.current = variant; this.selected = variant.options.slice(); this.querySelectorAll('[data-lux-option]').forEach(radio => radio.checked = this.selected[Number(radio.dataset.luxOption)] === radio.value); this.update(false); }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.layoutObserver?.disconnect(); this.cookieObserver?.disconnect(); if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame); this.stickyFrame = null; this.initialized = false; }
    showImage(src, id, alt) {
      setImage(this.querySelector('.lux-main-image'), src);
      if (alt) this.querySelector('.lux-main-image').alt = alt;
      this.querySelectorAll('[data-lux-thumbnail]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaId === String(id))));
    }
    scheduleSticky() {
      if (this.stickyFrame) return;
      this.stickyFrame = requestAnimationFrame(() => {
        this.stickyFrame = null;
        const sticky = this.querySelector('[data-lux-sticky]');
        if (!sticky || !this.isConnected) return;
        const cookie = document.querySelector('#shopify-pc__banner');
        const cookieVisible = cookie && cookie.getBoundingClientRect().height > 0 && getComputedStyle(cookie).visibility !== 'hidden' && getComputedStyle(cookie).display !== 'none';
        const viewport = window.visualViewport;
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const headerBottom = Math.max(0, document.querySelector('.lux-header')?.getBoundingClientRect().bottom || 0);
        const button = this.form.querySelector('[data-lux-add]').getBoundingClientRect();
        const visibleHeight = Math.max(0, Math.min(button.bottom, viewportBottom) - Math.max(button.top, headerBottom));
        const mainButtonVisible = visibleHeight >= button.height * 0.75;
        const editing = document.activeElement?.matches('input,select,textarea,[contenteditable="true"]');
        const keyboardOpen = editing && viewport && viewport.height < window.innerHeight * 0.75;
        const hide = mainButtonVisible || cookieVisible || keyboardOpen || !!document.querySelector('dialog[open]');
        if (sticky.hidden !== !!hide) sticky.hidden = !!hide;
      });
    }
    update(changeUrl) {
      const variant = this.current;
      this.querySelectorAll('[data-lux-option-group]').forEach(fieldset => {
        const index = Number(fieldset.dataset.luxOptionGroup);
        fieldset.querySelector('[data-lux-selected-option]').textContent = this.selected[index];
        fieldset.querySelectorAll('[data-lux-option]').forEach(radio => {
          const matches = this.variants.filter(candidate => candidate.options.every((option, i) => option === (i === index ? radio.value : this.selected[i])));
          radio.disabled = this.busy || matches.length === 0;
          const sold = matches.length > 0 && matches.every(candidate => !candidate.available);
          radio.closest('.lux-option').classList.toggle('is-sold-out', sold);
          radio.parentElement.querySelector('[data-lux-option-status]').textContent = matches.length === 0 ? strings.unavailable : sold ? strings.soldOut : '';
        });
      });
      this.selector.value = variant ? String(variant.id) : '';
      this.selector.disabled = !variant;
      this.querySelectorAll('[data-lux-price],[data-lux-sticky-price]').forEach(node => node.textContent = variant ? cleanMoney(variant.money) : '—');
      this.querySelectorAll('[data-lux-compare-price],[data-lux-sticky-compare-price]').forEach(node => {
        const showCompare = variant && variant.comparePrice > variant.price;
        node.textContent = showCompare ? cleanMoney(variant.compareMoney) : '';
        node.closest('[data-lux-compare-wrap]').hidden = !showCompare;
      });
      const measure = variant ? dimensions(variant) : { width: null, height: null };
      const sizeText = measure.width ? `${measure.width} × ${measure.height} cm` : this.selected.join(' / ');
      this.querySelectorAll('[data-lux-dimensions],[data-lux-spec-dimensions]').forEach(node => node.textContent = sizeText);
      this.querySelector('[data-lux-sticky-variant]').textContent = this.selected.filter(option => option !== 'Default Title').join(' / ') || this.querySelector('h1').textContent;
      this.querySelector('[data-lux-availability]').textContent = variant ? status(variant) : strings.unavailable;
      this.querySelector('.lux-availability').classList.toggle('is-unavailable', !variant?.available || (variant.managed && !variant.inStock));
      const fastDelivery = !!(variant?.available && variant.managed && variant.inStock);
      this.querySelector('[data-lux-delivery-text]').textContent = fastDelivery ? strings.delivery : strings.askDelivery;
      this.querySelector('[data-lux-delivery-icon]').hidden = !fastDelivery;
      this.updatePayments();
      this.querySelectorAll('[data-lux-add],[data-lux-sticky-add]').forEach(button => { const availableText = button.hasAttribute('data-lux-sticky-add') ? strings.addShort : strings.add; button.disabled = this.busy || !variant?.available; button.querySelector('span').textContent = this.busy ? strings.adding : !variant ? strings.unavailable : !variant.available ? strings.soldOut : availableText; });
      if (variant?.image && changeUrl) this.showImage(variant.image, variant.image_id, `${this.querySelector('h1').textContent} — ${variant.title}`);
      if (changeUrl) { const url = new URL(location.href); if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant'); history.replaceState(history.state, '', url); this.dispatchEvent(new CustomEvent('lux:variant-change', { bubbles: true, detail: { productId: this.dataset.productId, variantId: variant?.id || null } })); }
      this.scheduleSticky();
    }
    updatePayments() {
      const row = this.querySelector('[data-lux-klarna]');
      if (!row) return;
      const variant = this.current;
      row.hidden = !variant?.available || !(variant.price > 0);
      const quantity = Number(this.form.querySelector('[name="quantity"]').value);
      const text = quantity === 1 && variant?.installmentMoney
        ? strings.installment.replace('[amount]', cleanMoney(variant.installmentMoney))
        : strings.installmentGeneric;
      row.querySelector('[data-lux-installment-copy]').textContent = text;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.current?.available || !this.form.reportValidity()) return;
      const error = this.querySelector('[data-lux-error]');
      error.hidden = true;
      const data = new FormData(this.form);
      data.set('id', String(this.current.id));
      data.set('sections', 'lux-cart-drawer');
      data.set('sections_url', location.pathname + location.search);
      this.busy = true;
      this.update(false);
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || strings.error);
        if (!replaceDrawer(result.sections?.['lux-cart-drawer'])) location.assign(`${root}cart`);
      } catch (failure) { error.textContent = failure.message || strings.error; error.hidden = false; }
      finally { this.busy = false; this.update(false); }
    }
  }
  class LuxCollection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.inputs = [...this.querySelectorAll('[data-lux-filter]')];
      this.cards = [...this.querySelectorAll('[data-lux-card]')].map((element, index) => {
        const optionNames = JSON.parse(element.dataset.optionNames);
        const colourIndex = optionNames.findIndex(name => /kleur|color|afwerking/i.test(name));
        const variants = JSON.parse(element.querySelector('[data-lux-variants]').textContent).map(variant => ({ ...variant, ...dimensions(variant), finish: colourIndex >= 0 ? variant.options[colourIndex] : element.dataset.finish || '' }));
        const img = element.querySelector('.lux-card__image');
        return { element, index, variants, image: img, src: img?.getAttribute('src'), srcset: img?.getAttribute('srcset'), selection: element.querySelector('[data-lux-card-selection]').textContent };
      });
      const values = {
        vorm: [...new Set(this.cards.map(card => card.element.dataset.shape).filter(Boolean))],
        breedte: [...new Set(this.cards.flatMap(card => card.variants.map(variant => variant.width).filter(Boolean)))].sort((a, b) => a - b),
        hoogte: [...new Set(this.cards.flatMap(card => card.variants.map(variant => variant.height).filter(Boolean)))].sort((a, b) => a - b),
        licht: [...new Set(this.cards.map(card => card.element.dataset.light).filter(value => value && value !== 'onbekend'))],
        afwerking: [...new Set(this.cards.flatMap(card => card.variants.map(variant => variant.finish).filter(Boolean)))],
        extra: [...new Set(this.cards.flatMap(card => card.element.dataset.features.split(',').filter(Boolean)))]
      };
      for (const [key, options] of Object.entries(values)) {
        const select = this.inputs.find(input => input.dataset.luxFilter === key);
        for (const value of options) { const option = document.createElement('option'); option.value = value; option.textContent = key === 'vorm' ? strings.shapeLabels[value] || value : key === 'licht' ? strings.lightLabels[value] || value : key === 'extra' ? strings.featureLabels[value] || value : ['breedte', 'hoogte'].includes(key) ? `${value} cm` : value; select.append(option); }
        select.closest('label').hidden = options.length === 0;
      }
      this.addEventListener('change', event => { if (event.target.matches('[data-lux-filter]')) this.apply(true); }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-lux-reset]')) { this.inputs.forEach(input => { if (input.type === 'checkbox') input.checked = false; else input.value = ''; }); this.apply(true); }
        const remove = event.target.closest('[data-lux-remove-filter]');
        if (remove) { const input = this.inputs.find(value => value.dataset.luxFilter === remove.dataset.luxRemoveFilter); if (input.type === 'checkbox') input.checked = false; else input.value = ''; this.apply(true); }
        if (event.target.closest('[data-lux-filter-toggle]')) { const panel = this.querySelector('.lux-filter-panel'); panel.hidden = !panel.hidden; this.querySelector('.lux-filter-button').setAttribute('aria-expanded', String(!panel.hidden)); }
      }, { signal: this.abort.signal });
      window.addEventListener('popstate', () => this.fromUrl(), { signal: this.abort.signal });
      window.addEventListener('hashchange', () => this.fromUrl(), { signal: this.abort.signal });
      this.fromUrl();
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
    fromUrl() {
      const params = new URLSearchParams(location.hash.slice(1));
      this.inputs.forEach(input => { const value = params.get(input.dataset.luxFilter) || ''; if (input.type === 'checkbox') input.checked = value === '1'; else if (input.tagName === 'SELECT' && value && ![...input.options].some(option => option.value === value)) { const unavailable = document.createElement('option'); unavailable.value = value; unavailable.textContent = `${value}${['breedte', 'hoogte'].includes(input.dataset.luxFilter) ? ' cm' : ''}`; input.append(unavailable); input.value = value; } else input.value = value; });
      this.apply(false);
    }
    apply(writeUrl) {
      const state = Object.fromEntries(this.inputs.map(input => [input.dataset.luxFilter, input.type === 'checkbox' ? input.checked ? '1' : '' : input.value]));
      const active = Object.entries(state).filter(([key, value]) => value && key !== 'sortering');
      const variantFilter = ['breedte', 'hoogte', 'afwerking', 'vanaf', 'tot', 'beschikbaar'].some(key => state[key]);
      const visible = [];
      for (const card of this.cards) {
        const productMatches = (!state.vorm || card.element.dataset.shape === state.vorm) && (!state.licht || card.element.dataset.light === state.licht) && (!state.extra || card.element.dataset.features.split(',').includes(state.extra));
        const matches = card.variants.filter(variant => (!state.breedte || variant.width === Number(state.breedte)) && (!state.hoogte || variant.height === Number(state.hoogte)) && (!state.afwerking || variant.finish === state.afwerking) && (!state.beschikbaar || variant.available) && (!state.vanaf || variant.price >= Number(state.vanaf) * 100) && (!state.tot || variant.price <= Number(state.tot) * 100));
        card.element.hidden = !productMatches || matches.length === 0;
        if (card.element.hidden) continue;
        const available = matches.filter(variant => variant.available);
        const choices = (available.length ? available : matches).slice().sort((a, b) => a.price - b.price);
        const chosen = choices[0];
        card.sortPrice = chosen.price;
        visible.push(card);
        const compareNode = card.element.querySelector('[data-lux-card-compare-price]');
        const showCompare = chosen.comparePrice > chosen.price;
        compareNode.textContent = showCompare ? cleanMoney(chosen.compareMoney) : '';
        compareNode.hidden = !showCompare;
        card.element.querySelector('[data-lux-card-price]').textContent = cleanMoney(chosen.money);
        card.element.querySelector('[data-lux-card-stock]').textContent = !chosen.available ? strings.soldOut : chosen.managed && !chosen.inStock ? strings.orderable : '';
        card.element.querySelectorAll('[data-lux-card-link]').forEach(link => { const url = new URL(card.element.dataset.productUrl, location.origin); if (variantFilter) url.searchParams.set('variant', chosen.id); link.href = url.pathname + url.search; });
        card.element.querySelector('[data-lux-card-selection]').textContent = variantFilter ? matches.length === 1 ? chosen.title.replace(/x/g, ' × ') : `${state.breedte ? `${state.breedte} cm ${strings.wide} · ` : ''}${matches.length} ${strings.options}` : card.selection;
        if (variantFilter && chosen.image) setImage(card.image, chosen.image);
        else if (card.image) { card.image.setAttribute('src', card.src); if (card.srcset) card.image.setAttribute('srcset', card.srcset); else card.image.removeAttribute('srcset'); }
      }
      if (state.sortering === 'price-ascending') visible.sort((a, b) => a.sortPrice - b.sortPrice);
      else if (state.sortering === 'price-descending') visible.sort((a, b) => b.sortPrice - a.sortPrice);
      else if (state.sortering === 'title-ascending') visible.sort((a, b) => a.element.dataset.name.localeCompare(b.element.dataset.name, this.dataset.locale));
      else visible.sort((a, b) => a.index - b.index);
      const grid = this.querySelector('[data-lux-grid]');
      const fragment = document.createDocumentFragment();
      visible.forEach(card => fragment.append(card.element));
      this.cards.filter(card => card.element.hidden).forEach(card => fragment.append(card.element));
      grid.replaceChildren(fragment);
      this.querySelector('[data-lux-results]').textContent = `${visible.length} ${strings.models}`;
      this.querySelector('[data-lux-empty]').hidden = visible.length > 0;
      this.querySelector('[data-lux-filter-count]').textContent = active.length ? `(${active.length})` : '';
      const chips = this.querySelector('[data-lux-active-filters]');
      chips.replaceChildren();
      for (const [key, value] of active) {
        const input = this.inputs.find(node => node.dataset.luxFilter === key);
        const button = document.createElement('button'); button.type = 'button'; button.dataset.luxRemoveFilter = key;
        const label = key === 'beschikbaar' ? strings.stockFilter : input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent : `${input.parentElement.firstChild.textContent.trim()}: ${value}`;
        button.textContent = `${label} ×`; chips.append(button);
      }
      if (writeUrl) { const params = new URLSearchParams(); Object.entries(state).forEach(([key, value]) => { if (value) params.set(key, value); }); const url = new URL(location.href); url.hash = params.toString(); history.pushState(null, '', url); }
    }
  }
  class LuxReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.track = this.querySelector('[data-lux-review-track]');
      this.previous = this.querySelector('[data-lux-review-direction="-1"]');
      this.next = this.querySelector('[data-lux-review-direction="1"]');
      this.navigation = this.querySelector('[data-lux-review-navigation]');
      this.position = this.querySelector('[data-lux-review-position]');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-lux-review-direction]');
        if (!button) return;
        const step = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: Number(button.dataset.luxReviewDirection) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.abort.signal });
      this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal: this.abort.signal });
      this.resize = new ResizeObserver(() => this.updateNavigation());
      this.resize.observe(this.track);
      this.updateNavigation();
    }
    updateNavigation() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.navigation.hidden = maximum < 3;
      this.previous.disabled = this.track.scrollLeft < 3;
      this.next.disabled = this.track.scrollLeft > maximum - 3;
      const step = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      this.position.textContent = String(Math.round(this.track.scrollLeft / step) + 1) + ' / ' + this.track.children.length;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.initialized = false; }
  }
  if (!customElements.get('lux-review-carousel')) customElements.define('lux-review-carousel', LuxReviewCarousel);
  if (!customElements.get('lux-product')) customElements.define('lux-product', LuxProduct);
  if (!customElements.get('lux-collection')) customElements.define('lux-collection', LuxCollection);
})();
  } catch(e) { console.error(e); }
})();

})();
